import React from "react";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogDeleteShell from "./DialogDeleteShell";

export default function dialogGlbDelete(props) {
  const file = _.get(props, "glbToDelete.file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(props, "glbToDelete.name") || file;
  const assetName = baseName && !baseName.includes(".") ? baseName + ext : baseName;

  const handleDelete = (progressID) => {
    return fetch(getServerUri("glb/deleteOne"), {
      method: "DELETE",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        glbID: props.glbToDelete._id,
        fileName: _.get(props.glbToDelete, "file"),
        progressID: progressID || "",
      }),
    }).then((response) => {
      if (response.status === 200) {
        let newGlbs = _.cloneDeep(props.glbs);
        newGlbs.splice(
          newGlbs.indexOf(newGlbs.filter((glb) => glb._id === props.glbToDelete._id)[0]),
          1
        );
        props.deleteGlbFromGlbs(props.glbToDelete._id);
        props.setGlbs(newGlbs);
        if (newGlbs.length > 0) {
          if (props.glbToDelete._id === props.selectedGlbID) props.selectGlb(newGlbs[0]._id);
        } else props.selectGlb("");
        props.createSnackbar("Glb deleted", "success");
        return true;
      } else {
        response.text().then(console.log).catch(console.error);
        return false;
      }
    });
  };

  return (
    <DialogDeleteShell
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      assetName={assetName}
      assetID={_.get(props, "glbToDelete._id")}
      assetFile={_.get(props, "glbToDelete.file")}
      assetType="glb"
      onConfirmDelete={handleDelete}
      createSnackbar={props.createSnackbar}
      errorMessage="An error occurred deleting the glb."
    />
  );
}
